import { createContext, useContext, useEffect, useState } from 'react';
import { api } from './utils/api';

const UserContext = createContext({
  currentUser: null,
  setCurrentUser: () => {},
  refreshUser: async () => {},
  loading: false,
});

export function useCurrentUser() {
  return useContext(UserContext);
}

export function UserProvider({ children }) {
  const [currentUser, setCurrentUser] = useState(null);
  const [loading, setLoading] = useState(true);

  const refreshUser = async () => {
    setLoading(true);
    const token = localStorage.getItem('refresh_token');

    if (!token) {
      setCurrentUser(null);
      setLoading(false);
      return;
    }

    try {
      const { data } = await api.get('/users/me');
      setCurrentUser(data);
    } catch (err) {
      console.error('Failed to fetch user:', err);
      setCurrentUser(null);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    refreshUser();
  }, []);

  return (
    <UserContext.Provider value={{ currentUser, setCurrentUser, refreshUser, loading }}>
      {children}
    </UserContext.Provider>
  );
}
